<div class="innerpage-fullwithbanner">
  <h2 class="bighead">{{pageHeading}}</h2>
  <ul class="bread-crumbs">
    <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
      <a (click)="onHomeBreadCrumbClick();">
        Home
        <span>|</span>
      </a>
    </li>
    <li *ngIf="this.authService.Admin()||this.authService.SuperAdmin()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li><a href="#" [routerLink]="['/market-snapshot']" [queryParams]="{opentab: '6'}">Standard Users<span>|</span></a></li>
    <li>{{pageHeading}}</li>
  </ul>
</div>

<div class="section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div margin0">
      <h2 class="mainhead "><span class="text">Profile</span></h2>
      <div class="leftsideprofile">
        <div *ngIf="!IsEditMode" class="profilepic">
          <img #profilePic src="{{userInputModel.ProfilePicPath}}">
          <file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) (selectedFilePathEmitter)="selectedFilePathEmitter($event)" [uploadType]="fileUploadType" [clearFilescounter]="clearFiles"></file-upload>
          <a *ngIf="imageIdToDelete != null" href="javascript:void(0);" (click)="openModalForDelete(template,'deletemodal',imageIdToDelete,'the profile picture')" class="deletepic" triggers="hover" tooltip="Remove">
            <i class="icofont icofont-close icon"></i>
          </a>
        </div>
        <div *ngIf="IsEditMode" class="profilepic">
          <img #profilePic src="{{userInputModel.ProfilePicPath}}">
        </div>
      </div>
      <div class="rightsideprofile">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">First Name<span class="red">*</span></label>
              <input class="form-control" [disabled]="(IsEditMode)" (keydown)="onKeydown($event)" #firstNameinput="ngModel" [(ngModel)]="userInputModel.FirstName" autocomplete="off" required type="text" maxlength="30">
              <p class="redtext" *ngIf="!showFNSpecCharVal && (firstNameValid && firstNameinput.invalid && firstNameinput.touched)">First name is required </p>
              <p class="redtext" *ngIf="!showFNSpecCharVal && (!firstNameValid)">First name is required </p>
              <p class="redtext" *ngIf="showFNSpecCharVal">{{specCharValMsg}}</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" [disabled]="(IsEditMode)" (keydown)="onKeydown($event)" #lastNameinput="ngModel" [(ngModel)]="userInputModel.LastName" autocomplete="off" required type="text" maxlength="30">
              <p class="redtext" *ngIf="!showLNSpecCharVal &&  (lastNameValid && lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
              <p class="redtext" *ngIf="!showLNSpecCharVal && (!lastNameValid)">Last name is required </p>
              <p class="redtext" *ngIf="showLNSpecCharVal">{{specCharValMsg}}</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span *ngIf="userInputModel.UserRoleId !== userRole.ComplianceBroker" class="red">*</span></label>
              <input class="form-control" (keydown)="onKeydown($event)" [disabled]="(IsEditMode && !enablePasswordInput)" #emailinput="ngModel" (change)="validateemail()" autocomplete="off" [(ngModel)]="userInputModel.EmailAddress" required type="text" maxlength="100">
              <p class="redtext" *ngIf="(emailValid) && emailinput.invalid && emailinput.touched && userInputModel.UserRoleId !== userRole.ComplianceBroker">Email is required</p>
              <p class="redtext" *ngIf="(!emailValid) && emailvalidation =='' && userInputModel.UserRoleId !== userRole.ComplianceBroker">Email is required</p>
              <p class="redtext" *ngIf="(emailvalidation!='' && userInputModel.EmailAddress!='' && userInputModel.UserRoleId !== userRole.ComplianceBroker)">{{emailvalidation}}</p>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" #phoneNumberinput="ngModel" (keydown)="onKeydown($event)" required [(ngModel)]="userInputModel.PhoneNumber" mask='(000) 000-0000' type="text" maxlength="20">
              <p class="redtext" *ngIf="(phoneValid) && phoneNumberinput.invalid && phoneNumberinput.touched">Phone number is required</p>
              <p class="redtext" *ngIf="(!phoneValid)">Phone number is required</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <a href="javascript:void(0);" (click)="AddProperty(AddPropertyModal,'portfolio-bov-modal');" style="color: #198fde">
              + Property Access
            </a>
            <p class="redtext" *ngIf="(addPropertyValidation!='')">{{addPropertyValidation}}</p>
          </div>
          <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
  <div class="form-group">
    <label class="form-label">
      Property
      <span class="star">*</span>
    </label>-->
          <!--<div class="select-dropdown multiselectdesign">
    <ss-multiselect-dropdown formControlName="lstPropertyType" [options]="propertyLst" [(ngModel)]="selectedpropertyIds" [settings]="defaultTypeSettings" [texts]="defaultTypeText" (ngModelChange)="redrawTable()"></ss-multiselect-dropdown>
  </div>-->
          <!--<div *ngIf="(lstPropertyType.invalid && isSubmitted)">
    <p class="redtext" *ngIf="lstPropertyType.errors.required">
      Property type is required
    </p>
  </div>-->
          <!--</div>
  </div>-->
        </div>
      </div>
      <div class="clearfix"></div>

      <br />


      <div class="text-right">
        <button type="button" class="btn btn-default btn-lg" (click)="clearFeilds();">Cancel</button>
        <button class="btn btn-success  btn-lg" (click)="saveUser();">Save</button>
      </div>
    </div>
  </div>
</div>
<ng-template #AddPropertyModal>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Properties With Access</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefBov.hide()">
      <span aria-hidden="true">X</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group" *ngIf="properties?.length==0">
      <h6 class="info-text  margin-top-15 margin-bottom-30">Please add a property</h6>
    </div>
    <div class="row" *ngIf="properties!=null && properties?.length>0">
      <ul *ngFor="let myList of properties;let j = index ">
        <li class="transition" *ngIf="j==0">
          <label class="custom-checkbox withoutlabel margin-bottom-10">
            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i> <span class="requestBovTenant">Select All</span>
          </label>
        </li>
        <li class="transition">
          <label class="custom-checkbox withoutlabel">
            <input type="checkbox" [(ngModel)]="myList.IsChecked" (change)="onCheckboxChange($event.target.checked,myList.Guid);" class="ng-pristine ng-valid ng-touched"><i></i> <span class="requestBovTenant">{{myList.PropertyName}}</span>
          </label>
        </li>
      </ul>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefBov.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" *ngIf="properties!=null && properties?.length>0" (click)="AddPropertyToStandardUser();">Add</button>
    </div>
  </div>

</ng-template>
<!--<ng2-toasty [position]="'top-right'"></ng2-toasty>-->
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Profile Picture</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to delete {{deleteTask}}?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="onRemoveImage(imageIdToDelete);modalRef.hide();">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #GrandAccess>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">The Requested user is already existed.Are you sure you want to proceed? </h6>
    </div>

    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="changeStatus(1);">NO</button>
      <button class="btn btn-lg btn-success" (click)="changeStatus(2);saveUser();">GrandAccess</button>
    </div>
  </div>
</ng-template>



